import React, { useEffect, useState } from "react";
import { fetchAwardsPage } from "../api/awardsPage";
import { useHomePage } from "../context/HomePageContext";

const AwardsPage = () => {
  const { setContact } = useHomePage();
  const [awards, setAwards] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadAwardsPage = async () => {
      try {
        const data = await fetchAwardsPage();
        if (!isMounted) return;

        setAwards(data.awards);
        if (data.contact) {
          setContact(data.contact);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadAwardsPage();

    return () => {
      isMounted = false;
    };
  }, [setContact]);

  if (awards.length === 0) return null;

  return (
    <section className="relative overflow-hidden bg-white pb-16 pt-10 md:pb-20 md:pt-12 lg:pb-24">
      <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-7">
          {awards.map((award) => (
            <article
              key={award.id}
              className="overflow-hidden rounded-[12px] border border-[#E6E6E6] bg-white p-3 shadow-[0_2px_12px_rgba(0,0,0,0.03)]"
            >
              <div className="overflow-hidden rounded-[8px] bg-[#F7F7F7]">
                <img
                  src={award.image}
                  alt={award.title}
                  referrerPolicy="no-referrer"
                  className="aspect-[4/3] h-auto w-full object-cover"
                />
              </div>
              <h3 className="mt-4 px-1 pb-2 text-[15px] font-bold leading-snug text-brand-purple md:text-[16px]">
                {award.title}
              </h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsPage;
